import { Dataset } from '../../types/types';
import { DATASET_ITEM_VISIBILITY_KEYS } from '../../constants';

// True when both datasets carry identical per-item visibility values
export const hasSameItemVisibility = (a: Dataset, b: Dataset): boolean => {
  const aItems = a.items ?? [];
  const bItems = b.items ?? [];

  if (aItems.length !== bItems.length) {
    return false;
  }

  return aItems.every((item, index) =>
    DATASET_ITEM_VISIBILITY_KEYS.every(
      (key) => item[key] === bItems[index][key]
    )
  );
};
